import {Component, Inject, OnInit, Optional, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {ApiServiceService} from '../api-service.service';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.css']
})

export class NotFoundComponent implements OnInit {
    constructor(@Inject(PLATFORM_ID) private platformId: Object,
                @Optional() @Inject(ApiServiceService.RESPONSE) private response: any) {
    }

    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            this.response.status(404);
        }
    }
}
